export const VDJCN = {
  'VDJ.Title': 'V(D)J分析',
  'VDJ.Type': '分析类型',
  'VDJ.File.Title': '注释文件',
  'VDJ.File.Table.Title2': 'Contig注释文件',
  'VDJ.File.Delete.Tips': '是否删除文件',
  'VDJ.Clonotype': '克隆类型',
  'VDJ.Double.Chain.Data': '是否仅使用双链数据进行分析',
  'VDJ.Required.Tips': '请完成必填项',

  'VDJ.Result.Title': '克隆型和VJ基因使用情况',
  'VDJ.Result1.Title': '克隆型频率分布柱状图',
  'VDJ.Result1.Des': '展示分组中不同克隆型频率分类的占比分布。克隆型频率定义：Single: 1，Medium: 2~10, Large: 11~∞。',
  'VDJ.Result1.Marker': '克隆型频率分布柱状图',

  "VDJ.Result2.Title": '细胞类型克隆型频率分布',
  "VDJ.Result2.Marker": '细胞类型克隆型频率分布',
  "VDJ.Result2.Des": '每个分组内部不同细胞类型的克隆型频率分类占比分布，包含未匹配到V(D)J信息的细胞。克隆型频率定义：Single: 1，Medium: 2~10, Large: 11~∞。',

  'VDJ.Result3.Title': '克隆型频率分布饼图',
  'VDJ.Result3.Marker': '克隆型频率分布饼图',
  'VDJ.Result3.Des': '展示分组在不同细胞类型中，不同克隆型频数分类占比，圆圈大小代表总克隆型数目。克隆型频率定义：Single: 1，Medium: 2~10, Large: 11~∞。',

  'VDJ.Result4.Title': 'α/β链VJ基因使用频率热图',
  'VDJ.Result4.Marker': 'α/β链VJ基因使用频率热图',
  'VDJ.Result4.Des': '每个组内各细胞类型中α链/轻链及β链/重链VJ基因使用频率热图。横坐标V基因和J基因，纵坐标是细胞类型。',

  'VDJ.Result5.Title': 'α和β双链VJ基因频率热图',
  'VDJ.Result5.Marker': 'α和β双链VJ基因频率热图',
  'VDJ.Result5.Des': '分组内双链中VJ基因的使用频数。横坐标是双链的 V 基因，纵坐标是双链的 J 基因，颜色的深浅表示频数的大小。',

  'VDJ.Result6.Title': 'D50多样性指数',
  'VDJ.Result6.Marker': 'D50多样性指数',
  'VDJ.Result6.Des': '展示了占据免疫库50%总量的克隆型数量。D50值越大，说明免疫库的多样性越高，不同克隆型的丰度分布越均匀。',
};

export const VDJUS = {
  'VDJ.Title': 'Explore V(D)J analysis',
  'VDJ.Type': 'Type',
  'VDJ.File.Title': 'Annotation file',
  'VDJ.File.Table.Title2': 'Contig annotation file',
  'VDJ.File.Delete.Tips': 'Are you sure to delete the file?',
  'VDJ.Clonotype': 'Clonotype',
  'VDJ.Double.Chain.Data': 'Only use double chain data',
  'VDJ.Required.Tips': 'Please complete the required fields',

  'VDJ.Result.Title': 'Clonotypes and VJ genes usages',
  'VDJ.Result1.Title': 'Clonotype frequency bar plot',
  'VDJ.Result1.Marker': 'clonotype_frequency_bar_plot',
  'VDJ.Result1.Des': 'Show the proportion distribution of different clonotype frequency classification in the group. Clonotype frequency definition: Single: 1, Medium: 2~10, Large: 11~∞.',

  "VDJ.Result2.Title": 'Clonotype frequency per cell type',
  "VDJ.Result2.Marker": 'clonotype_frequency_per_cell_type',
  "VDJ.Result2.Des": 'The distribution of clonotype frequency categories for cell types within each group, including cells without matched V(D)J information. clonotype frequency is defined as follows: Single: 1, Medium: 2–10, Large: 11–∞.',

  'VDJ.Result3.Title': 'Clonotype frequency pie plot',
  'VDJ.Result3.Marker': 'clonotype_frequency_pie_plot',
  'VDJ.Result3.Des': 'The proportion of different clonotype frequency categories in different cell types within the groups, with the circle size. clonotype frequency is defined as follows: Single: 1, Medium: 2–10, Large: 11–∞. representing the total nmuber of clonotypes.',

  "VDJ.Result4.Title": 'VJ gene frequencies in α/β chains',
  "VDJ.Result4.Marker": 'VJ_gene_frequencies_in_α/β_chains',
  "VDJ.Result4.Des": 'α-chains and β-chains VJ usage frequency for each cell type within each group. The x-axis represents the V and J genes, and the y-axis represents the cell types.',

  'VDJ.Result5.Title': 'VJ gene combinations in α and β chains',
  'VDJ.Result5.Marker': 'VJ_gene_combinations_in_α_and_β_chains',
  'VDJ.Result5.Des': 'VJ gene usage frequency in α and β double chains within each group. The x-axis represents the V genes, the y-axis represents the J genes, and the color intensity indicates the frequency of usage.',

  'VDJ.Result6.Title': 'D50 diversity index',
  'VDJ.Result6.Marker': 'D50_diversity_index',
  'VDJ.Result6.Des': 'Number of clonotypes occupying the 50% of repertoires. The higher the D50 value, the more diverse the repertoire is, with a more even distribution of clonotype abundances.',
};